<template>
  <DropdownComponent class="filter-checklist" :close-on-click="false">
    <template #default>
      <InputComponent :label="$attrs.options.label">
        <ButtonComponent :icon="['fal', 'angle-down']">
          <template #label>
            <slot :name="$attrs['data-filter']" :items="valueComp">{{ valueComp.join(', ') }}</slot>
          </template>
        </ButtonComponent>
      </InputComponent>
    </template>
    <template #dropdown>
      <Checklist :value="valueComp" @input="$ev => $emit('input', $ev)" v-bind="$attrs.options" />
    </template>
  </DropdownComponent>
</template>

<script>
import { DropdownComponent } from 'vue-elder-dropdown'
import { InputComponent } from 'vue-elder-input'
import Checklist from '@/components/Select/Checklist'

export default {
  props: {
    value: [Array, String, Boolean],
  },
  computed: {
    valueComp() {
      if ([null, undefined].includes(this.value)) return []
      return this.value instanceof Array ? this.value : [this.value]
    },
  },
  components: {
    DropdownComponent,
    Checklist,
    InputComponent,
  },
}
</script>

<style lang="scss">
.filter-checklist {
  .elder-input__field {
    border: none;
    background-color: transparent;
  }
}
</style>
